<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <!-- <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{initData.cu_name}}</em>
          </div>
        </div> -->
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">销售单号</label>
            <span class="weui-form-preview__value">{{initData.sa_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sa_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.sa_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.sa_seller}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">序号</label>
            <span class="weui-form-preview__value">{{initData.sd_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.sd_prodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div> -->
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单数</label>
            <span class="weui-form-preview__value">{{initData.sd_qty}}{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币别</label>
            <span class="weui-form-preview__value">{{initData.sa_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sd_netprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sd_delivery}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已出货数量</label>
            <span class="weui-form-preview__value">{{initData.pd_outqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已退货数量</label>
            <span class="weui-form-preview__value">{{initData.pd_inqty}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_ordertotal - initData.pd_nettotal}}</span>
          </div> -->
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已收款金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.recamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">费用分摊金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.discountAmount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已开发票金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_auditbillamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">未开发票金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.unBillAmount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{initData.sd_remark}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>